import { GetStaticPaths, GetStaticPropsContext } from 'next'
import Head from 'next/head'
import { GlobalProps, Layout, withLayoutProps } from 'slices/Layout'

import { REVALIDATION_FREQUENCY } from '@/shared/consts'
import {
  CompareDetailSlice,
  competitorBySlug,
  competitorSlugs,
  CompetitorEntry,
} from '@/slices/Compare'

interface CompareDetailPageProps extends GlobalProps {
  competitor: CompetitorEntry
}

export const getStaticProps = async (context: GetStaticPropsContext) => {
  const slug = context.params?.slug as string
  const competitor = competitorBySlug(slug)

  if (!competitor) {
    return { notFound: true }
  }

  return withLayoutProps<{ competitor: CompetitorEntry }>(context, {
    props: { competitor },
    revalidate: REVALIDATION_FREQUENCY,
  })
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: competitorSlugs().map((slug) => ({ params: { slug } })),
    fallback: false,
  }
}

const CompareDetailPage = ({ competitor, ...layoutProps }: CompareDetailPageProps) => {
  return (
    <>
      <Head>
        <title>{competitor.metaTitle}</title>
        <meta name="description" content={competitor.metaDescription} />
      </Head>
      <Layout {...layoutProps}>
        <CompareDetailSlice competitor={competitor} />
      </Layout>
    </>
  )
}

export default CompareDetailPage
